/**
 * GO/src/orderservice/orderservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VariantType = 'Invalid' | 'String' | 'Int' | 'Double' | 'DateTime' | 'Uuid' | 'ByteArray' | 'Bool';

export const VariantType = {
    Invalid: 'Invalid' as VariantType,
    String: 'String' as VariantType,
    Int: 'Int' as VariantType,
    Double: 'Double' as VariantType,
    DateTime: 'DateTime' as VariantType,
    Uuid: 'Uuid' as VariantType,
    ByteArray: 'ByteArray' as VariantType,
    Bool: 'Bool' as VariantType
};
